var map = {
    canvas: null,
    addresses: {
        oceancity: {
            lat: 38.331356,
            lng: -75.0918812,
            marker: {
                lat: 38.330356,
                lng: -75.0867812
            }
        },
        wisconsin: {
            lat: 43.6252271,
            lng: -89.768124,
            marker: {
                lat: 43.6250983,
                lng: -89.7662152
            }
        },
        virginia: {
            lat: 36.8472550,
            lng: -75.9876115,
            marker: {
                lat: 36.8459567,
                lng: -75.9809467
            }
        },
        williamsburg: {
            lat: 37.30999,
            lng: -76.7346927,
            marker: {
                lat: 37.310161 ,
                lng: -76.732472
            }
        }
    },
    markers: [],
    config: {
        disableDefaultUI: true,
        zoom: 16,
        styles: [
            {
                "featureType": "landscape",
                "stylers": [
                    { "saturation": -100 },
                    { "lightness": 65 },
                    { "visibility": "on" }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                    { "saturation": -100 },
                    { "lightness": 51 },
                    { "visibility": "off" }
                ]
            }, {
                "featureType": "road.highway",
                "stylers": [
                    { "hue": "#7C9C7B" },
                    { "lightness": 30 },
                    { "saturation": -97 },
                    { "visibility": "simplified" }
                ]
            }, {
                "featureType": "road.arterial",
                "stylers": [
                    { "saturation": -100 },
                    { "lightness": 30 },
                    { "visibility": "on" }
                ]
            }, {
                "featureType": "road.local",
                "stylers": [
                    { "saturation": -100},
                    { "lightness": 40},
                    { "visibility": "on"}
                ]
            }, {
                "featureType": "transit",
                "stylers": [
                    { "visibility": "off" }
                ]
            }, {
                "featureType": "administrative.province",
                "stylers": [
                    {"visibility": "off" }
                ]
            }, {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    { "visibility": "on"},
                    { "lightness": -25},
                    { "saturation": -100 }
                ]
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    { "hue": "#7C9C7B" },
                    { "lightness": 30 },
                    { "saturation": -97 }
                ]
            }
        ]
    },
    move: function() {
        "use strict";

        map.canvas.panTo(map.config.center);
    },
    ontilesloaded: function() {
        "use strict";

        $(".js-map").addClass("visible");
    },
    init: function() {
        "use strict";

        this.canvas = new google.maps.Map(document.getElementById("map-canvas"), map.config);

        for (var address in map.addresses) {
            var obj = map.addresses[address].marker;
            map.markers.push(
                new google.maps.Marker({
                    position: new google.maps.LatLng(obj.lat, obj.lng),
                    map: map.canvas
                })
            );
        }

        google.maps.event.addListener(this.canvas, "tilesloaded", this.ontilesloaded);
        google.maps.event.addListener(this.canvas, "resize", this.move);
    }
};

var parallax = function() {
    "use strict";

    var controller = new ScrollMagic();
    var selector = $(".js-parallax");
    var duration = selector.height() + $(window).height();
    var className = "+=translate";

    $.each(selector, function(index, elem) {
        var elemToAnimate = $(elem).find(".js-parallax-animate");
        var tween = TweenMax.to(elemToAnimate, 1, { className: className });
        var scene = new ScrollScene({ triggerElement: elem, duration: duration, offset: -100 }).setTween(tween).addTo(controller);
    });
};

var init = function() {
    "use strict";

    var config = {
        dropoff: {
            today: "",
            clear: "",
            close: "",
            klass: {
                input: "date-input",
                    active: "date-input-active",
                holder: "picker-holder",
                frame: "picker-frame",
                wrap: "picker-wrap",
                box: "picker-box",
                opened: "picker-opened",
                table: "picker-table",
                    header: "picker-header",
                        navPrev: "picker-nav picker-nav-prev",
                        navNext: "picker-nav picker-nav-next",
                        navDisabled: "picker-nav-disabled",
                    year: "picker-year",
                    month: "picker-month",
                    day: "picker-day",
                        selected: "picker-day-selected",
                        infocus: "picker-day-infocus",
                        outfocus: "picker-day-outfocus",
                        now: "picker-day-today"
            }
        },
        pickup: {
            today: "",
            clear: "",
            close: "",
            klass: {
                input: "date-input",
                    active: "date-input-active",
                holder: "picker-holder",
                frame: "picker-frame",
                wrap: "picker-wrap",
                box: "picker-box",
                opened: "picker-opened",
                table: "picker-table",
                    header: "picker-header",
                        navPrev: "picker-nav picker-nav-prev",
                        navNext: "picker-nav picker-nav-next",
                        navDisabled: "picker-nav-disabled",
                    year: "picker-year",
                    month: "picker-month",
                    day: "picker-day",
                        selected: "picker-day-selected",
                        infocus: "picker-day-infocus",
                        outfocus: "picker-day-outfocus",
                        now: "picker-day-today"
            },
            onSet: function() {
                $(".js-date-dropoff").pickadate("open");
            }
        },
        transfers: {
            customClass: "aff-select aff-select-transfers",
            placeholder: "Enter your airport",
            onChange: function() {
                $(".js-date-pickup").pickadate("open");
            }
        },
        contact: {
            customClass: "aff-select aff-select-contact",
            placeholder: "Select a city",
            onChange: function() {
                var city = $(this).val();
                var address = map.addresses[city];

                map.config.center = new google.maps.LatLng(address.lat, address.lng);
                if (map.canvas) {
                    map.move();
                } else {
                    map.init();
                }
                $(".js-city:visible").addClass("hidden");
                $(".js-" + city).removeClass("hidden");
            }
        }
    };

    $(".js-select-transfers").selectOrDie(config.transfers);
    $(".js-select-contact").selectOrDie(config.contact);

    $(".js-date-dropoff").pickadate(config.dropoff);
    $(".js-date-pickup").pickadate(config.pickup);

    $(".js-scroll-top").scrollToTop();
    $(".js-scroll-nav").scrollMenu();

    $("a[href*=\\#]").animateScroll({ speed: 600 });

    $(window).on("resize", function() {
        if (map.canvas) {
            google.maps.event.trigger(map.canvas, "resize");
        }
    });

    $(".js-tab").on("click", function() {
        var self = $(this),
            tabs = $(".js-tab"),
            what = self.data("service"),
            wrapper = self.closest(".js-services"),
            prev = tabs.filter(".is-active");

        if (self.hasClass("is-active")) {
            return false;
        }

        tabs.removeClass("is-active");
        self.addClass("is-active");
        prev.addClass("is-out");
        setTimeout(function() {
            prev.removeClass("is-out");
        }, 300);
        wrapper.removeClass(function(index, cssClass) {
            return (cssClass.match(/(^|\s)is-open-\S+/g) || []).join(" ");
        }).addClass("is-open is-open-" + what);
    });

    $(".js-center").on({
        mouseenter: function() {
            $(".js-centers-map").addClass("is-faded");
        },
        mouseleave: function() {
            $(".js-centers-map").removeClass("is-faded");
        }
    });

    $(".js-join-now").on({
        mouseenter: function() {
            $(".js-membership-card").addClass("is-hovered");
        },
        mouseleave: function() {
            $(".js-membership-card").removeClass("is-hovered");
        }
    });

    parallax();

};

$(document).ready(init);


$.fn.scrollMenu = function() {
    "use strict";

    var menu = this;
    var regex = /(^|\s)#([^ ]*)/g;
    var menuItems = menu.find("[href*=#]");
    var menuHeight = menu.outerHeight();
    var sections = menuItems.map(function() {
        var item = $(this).attr("href");
        item = (item.match(regex)) ? $(item) : null;
        if (item) {
            return item;
        }
    });

    $(window).scroll(function() {
        var windowY = $(window).scrollTop();
        var currentSection = sections.map(function() {
            if($(this).offset() != undefined){
                var sectionY = $(this).offset().top;
                if (sectionY < windowY + menuHeight) {
                    return this;
                }
            }
        });
        var currentMenu;
        var latestMenu;

        currentSection = currentSection[currentSection.length - 1];
        currentMenu = currentSection && currentSection.length ? currentSection[0].id : "";

        if (latestMenu !== currentMenu) {
            latestMenu = currentMenu;
            menuItems.removeClass("active").filter("[href='#" + currentMenu + "']").addClass("active");
        }
    });

    return this;
};

$.fn.scrollToTop = function() {
    "use strict";

    var elem = this;

    $(window).on("scroll load", function() {
        var height = $(window).height();
        var windowY = $(window).scrollTop();

        if (windowY > height) {
           elem.addClass("visible");
        } else {
           elem.removeClass("visible");
        }
    });

    $(this).on("click", function(event) {
        $("body").animate({ scrollTop: 0 });
        event.preventDefault();
    });

    return this;
};

$.fn.animateScroll = function(options) {
    "use strict";

    var self = this;
    var settings = $.extend({
        speed: 400
    }, options);

    $(self).on("click", function(event) {
        var wLocation = location.pathname.replace(/^\//,"");
        var wHost = location.hostname;
        var selfLocation = this.pathname.replace(/^\//,"");
        var selfHost = this.hostname;

        if (wLocation === selfLocation && wHost === selfHost) {
            var section = $(this.hash);
            var scrollTo;

            if (section.length) {
                scrollTo = section.offset().top;
            } else {
                scrollTo = 0;
            }

            $("body, html").animate({
                scrollTop: scrollTo
            }, settings.speed);
            event.preventDefault();
        }
    });

    return this;
};


function isTouchDevice() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function(query) {
        return window.matchMedia(query).matches;
    };

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}



